import { render, staticRenderFns } from "./releaseProduct.vue?vue&type=template&id=6d43c183&scoped=true"
import script from "./releaseProduct.vue?vue&type=script&lang=js"
export * from "./releaseProduct.vue?vue&type=script&lang=js"
import style0 from "./releaseProduct.vue?vue&type=style&index=0&id=6d43c183&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d43c183",
  null
  
)

export default component.exports